var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('article',{staticClass:"empty-state"},[_c('i',{class:[_vm.icon, 'fal', 'icon']}),_c('div',{staticClass:"cta"},[_vm._v(" "+_vm._s(_vm.cta)+" ")]),_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }